// Supabase client configuration following official Clerk + Supabase documentation
// https://clerk.com/docs/integrations/databases/supabase
import { createClient } from '@supabase/supabase-js'
import type { Database } from '../../database.types'

// Extend the ImportMeta interface to include env
declare global {
  interface ImportMeta {
    env: {
      VITE_SUPABASE_URL: string
      VITE_SUPABASE_ANON_KEY: string
      [key: string]: any
    }
  }
}

// This is used by components that need to create their own client with session access
// For a global client, components should use the useClerkSupabaseClient hook instead
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables')
}

// Basic unauthenticated client for public access
export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey)

// Function to create authenticated Supabase client using Clerk's native integration
// Following latest official Clerk docs: https://clerk.com/docs/integrations/databases/supabase
export function createClerkSupabaseClient(getToken: () => Promise<string | null>) {
  return createClient<Database>(supabaseUrl, supabaseAnonKey, {
    accessToken: getToken,
  })
}